































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Picker } from 'emoji-mart-vue-fast';
import 'emoji-mart-vue-fast/css/emoji-mart.css';
import type { IEmoji } from '../base-emoji/types/emoji';
import type { IEmojiLocalization } from '../base-emoji/types/emoji-localization';

@Component({
  name: 'BaseEmojiPicker',
  components: {
    Picker,
  },
})
export default class BaseEmojiPicker extends Vue {
  @Prop() localization?: IEmojiLocalization;
  @Prop({ default: '#FE9500' }) color?: string;
  @Prop() emojiIndex: any;

  skinChange(skinTone: number) {
    this.$emit('skinChange', skinTone);
  }

  hide() {
    this.$emit('hide');
  }

  select(emoji: IEmoji) {
    this.$emit('select', emoji);
  }
}
